import { render } from "./TheFavoritesWidget.vue?vue&type=template&id=18ca98ae"
import script from "./TheFavoritesWidget.vue?vue&type=script&lang=js"
export * from "./TheFavoritesWidget.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/application/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__